import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";
import Cookies from "js-cookie";


const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION === "true";


export const getBannerList = async (data) => {
    const access_token = Cookies.get("access_token");

    try {
        let params;

        if (isEncryptionEnabled) {
            const encryptedData = encryptData({ ...data, access_token });
            params = { reqData: encryptedData };
        } else {

            params = { ...data, access_token };
        }
        const response = await axios.get("/banners-list", { params });
        const decrypted = isEncryptionEnabled ? decryptData(response) : response.data;

        return decrypted;
    } catch (error) {
        console.error("Error inside getBannerList:", error);
        throw error;
    }
};
